export default "__VITE_ASSET__CluBG4$q__"